import { _ } from 'svelte-i18n';
import axios from 'axios';
import { get } from 'svelte/store';
import { url } from '../stores/url.js'; 
import { roles } from '../stores/roles.js'; 
import { users } from '../stores/users.js';  
import { permissions } from '../stores/permissions.js'; 
import { errorNotification, successNotification, warningNotification } from './html-helpers.js';
import { success } from 'toastr';

const backend_url = get(url);
const lan = get(_);
 
function hasPermission(user, permission) {
    return user.user_permission_pivot.some(upp => upp.permission.name == permission);
}


async function getPermissions() {
    const [ data, error ] = await request(`${backend_url}/permission/all`);
    if(!error) {
        permissions.set(data);
    }
}

async function getUsers() {
    const [ data, error ] = await request(`${backend_url}/user/all`);
    if(!error) {
        users.set(data);
    }
}

async function getRoles() {
    const [ data, error ] = await request( `${backend_url}/role/all`);
    if(!error) {
        roles.set(data);
    }
}



function getParam(q) {
    return (window.location.search.match(new RegExp('[?&]' + q + '=([^&]+)')) || [, null])[1];
}


function validateAxiosResponse(response) {
    if(response.status !== 200) {
        let error_msg = lan('unknown_error');
        let error_code = response.data?.error_code;
        if(error_code) {
            error_code = error_code.toString();
            if(error_code.includes('_') && error_code != 'permission_denied') {
                const arr_error_code = error_code.split('_'); // z.b. firstname_not-provided || password_confirm_incorrect
                const error_part_1 = lan(arr_error_code[0]); // -> Vorname
                const error_part_2 = lan(arr_error_code[1]); // -> nicht angegeben 
                error_msg = `${error_part_1} ${error_part_2}`;
            } else {
               error_msg = lan(error_code);
            }
        }       
        errorNotification(error_msg);
        return false;
    }
    return true;
}


let last_request = { type: '', url: '', occure: 0 };
async function request(url, data = null) {
    // Angaben für Funktion nicht ausreichen
    if(!url) {
        warningNotification(lan('invalid_arguments'));
        return [null, true];  // [success_data, error]
    }

    // Verhindern, dass selbe anfrage innerhalb von 500ms gesendet wird
    const now = new Date().getTime();
    if(last_request.url == url && ((last_request.occure + 500) > now)) {
        warningNotification(lan('same_request_to_soon'));
        return [null, true]; // 
    }
    last_request = { url: url, occure: now };

    // offline funktionalität -> return data with offline id und db id nachreichen

    // cache get requests in local storage by url

    // Validate Fields anhand data object key-values
    /*
    idee: nach key nullable true müssen die keys keine values mehr enthalten
    data: {
        name: 'ja',
        nullable: true,
        title: ''
    }
    */
    if(data) {
        for(const [key, value] of Object.entries(data)) {
            if(value == '') {
                // key = key.replace('_', '-'); 
                const error_part_1 = lan(key); // -> Vorname
                const error_part_2 = lan('not-provided'); // -> nicht angegeben 
                warningNotification(`${error_part_1} ${error_part_2}`);
                return [null, true];
            } 
    
            if(key == 'nullable') { // ab hier müssen die keys nicht mehr != null sein
                break;
            }
        }
    }
    

    const start = new Date().getTime(); 
    const type = data !== null ? 'post' : 'get';
    const response = await axios[type](url, data);
    const end = new Date().getTime();
    console.log(`${url} duration: ${end - start} ms`)
    if(validateAxiosResponse(response)) {
        return [response.data, false];
    }

    // Fehler auf dem Server bei bearbeitung
    return [null, true]; 
}

export  {
    hasPermission,
    getPermissions,
    getUsers,
    getRoles,
    getParam,
    validateAxiosResponse,
    request
}